const NAMESPACE = "product-description-expand";
(async()=>{
    const {showElement: e} = await import(window.theme.modules.utils);
    var t = await import(window.theme.modules.baseComponent);
    customElements.define(NAMESPACE, class extends t.default {
        elements = {
            content: "[data-content]",
            link: "[data-expand-link]"
        };
        expandThreshold = 150;
        render() {
            this.$content.offsetHeight > 1.25 * this.expandThreshold && (this.style.setProperty(`--${NAMESPACE}-height`, `${this.expandThreshold}px`),
            e(this.$link),
            this.$link.addEventListener("click", ()=>{
                this.toggleAttribute("expanded")
            }
            ))
        }
    }
    )
}
)();
